var _path;
import { jsx as _jsx } from "react/jsx-runtime";
var Car = function Car(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? 'tw-text-neutral-light-800' : _ref$className,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size;
  return /*#__PURE__*/_jsx("svg", {
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    children: _path || (_path = /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M2.586 4.586A2 2 0 0 1 4 4h9a1 1 0 0 1 1 1h4a1 1 0 0 1 .858.486l3 5A1 1 0 0 1 22 11v6a1 1 0 0 1-1 1h-1.17a3.001 3.001 0 0 1-5.66 0H9.83a3.001 3.001 0 0 1-5.66 0H3a1 1 0 0 1-1-1V6a2 2 0 0 1 .586-1.414ZM6 17a1 1 0 1 0 2 0 1 1 0 0 0-2 0Zm3.83-1a3.001 3.001 0 0 0-5.66 0H4V6h8v10H9.83ZM20 16h-.17a3.001 3.001 0 0 0-5.66 0H14v-4h6v4Zm-3 0a1 1 0 1 0 0 2 1 1 0 0 0 0-2Zm-3-9v3h5.234l-1.8-3H14Z",
      fill: "none",
      className: "tw-fill-current"
    }))
  });
};
export default Car;